export default "__VITE_ASSET__CVK3P1sY__"